<template lang="html">

<div class="subComponent">

  <el-dialog
    title="新增认证"
    :visible.sync="openstate"
    width="600px"
    @open="openHandle"
    @closed="handleClose">

    <div class="cbody">
        <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false">
            <div class="text-block clearfix">
                <div class="bName">主体类型</div>
                <div class="bContent">
                     <el-form-item prop="name">
                         <dic-select code="ztlx"
                              :selectId="params.subjectTypeId"
                              plaText="主体类型"
                              paramsKey="subjectType"
                              @selectChange="selectChange"/>
                     </el-form-item>
                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">身份类别</div>
                <div class="bContent">
                     <el-form-item prop="name">
                         <dic-select code="sflx"
                              :selectId="params.identityTypeId"
                              plaText="身份类型"
                              paramsKey="identityType"
                              @selectChange="selectChange"/>
                     </el-form-item>
                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">管理员</div>
                <div class="bContent">
                     <el-form-item prop="source">
                       <el-select
                         style="width:270px;"
                         v-model="adminId"
                         filterable
                         remote
                         placeholder="请输入关键词"
                         size="medium"
                         :remote-method="remoteMethod"
                         @change="adminChange"
                         :loading="loading">
                         <el-option
                           v-for="item in seekArr"
                           :key="item.id"
                           :label="item.realName"
                           :value="item.id">
                           <div>
                                 {{item.cellPhone | transPhone}}
                                 <span style="color:#999999;margin-left:3px;">{{item.realName}}</span>
                           </div>
                         </el-option>
                       </el-select>
                     </el-form-item>
                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">有效证件</div>
                <div class="bContent">
                    <!-- <el-button class="upBtn" type="primary" style="width:80px;" size="small">上传</el-button> -->
                    <firmUpload @imgChange="imgHandle1" />
                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">认证公函</div>
                <div class="bContent">
                    <!-- <el-button class="upBtn" type="primary" style="width:80px;" size="small">上传</el-button> -->
                    <firmUpload @imgChange="imgHandle2" />
                </div>
            </div>

        </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
        <el-button @click="openstate = false" size="small">取 消</el-button>
        <el-button @click="goSubAdd" size="small" type="primary">确 定</el-button>
    </div>
 </el-dialog>

</div>

</template>

<script>

import { userSeek } from "@/api/account";
import firmUpload from "./firmUpload";

export default {
    components:{
        firmUpload
    },
    filters:{
        transPhone:function(e){
            return e.substr(0,3) + '****' + e.substr(8,11);
        }
    },
    data(){
        return{
            openstate:false,
            adminId:'',
            seekArr:[],
            params:{
              id:'',
              status:'',
              cqjQiyeEnterpriseId:'',
              subjectType:'',
              subjectTypeId:'',
              identityType:'',
              identityTypeId:'',
              companyName:'',
              applicantName:'',
              applicantPhone:'',

              businessLicense:'',
              applicationCertDocId:''
            },
            rules:{
                subjectTypeId:[{
                   required: true,
                   trigger: 'blur'
                }],
                identityTypeId:[{
                   required: true,
                   trigger: 'blur'
                }],
                companyName:[{
                   required: true,
                   trigger: 'blur'
                }],
                applicantName:[{
                   required: true,
                   trigger: 'blur'
                }],
                applicantPhone:[{
                   required: true,
                   trigger: 'blur'
                }]
            }
        }
    },

    methods:{
        imgHandle1:function(e){
            this.params.businessLicense = e;
        },
        imgHandle2:function(e){
            this.params.applicationCertDocId = e;
        },
        adminChange:function(e){
            this.seekArr.forEach(item => {
                if(item.id == e){
                    this.params.applicantName = item.realName;
                    this.params.applicantPhone = item.cellPhone;
                };
                return ;
            })
        },
        remoteMethod:function(e){
            var key = e.replace(/\s+/g,'');
            if(key){
              var vues = this;
              userSeek({where:e,no:1,size:20,isOrganization:2}).then(res => {
                  vues.seekArr = [];
                  res.userListByWhereList.forEach((item, i) => {
                       if(item.cellPhone){
                           vues.seekArr.push(item);
                       }
                  });
              })
            }
        },
        selectChange:function(e){
            this.params[e.paramsKey] = e.name;
            this.params[e.paramsKey + 'Id'] = e.id;
        },
        goSubAdd:function(){
            var vues = this;
            vues.$emit('goStore',vues.params);
            vues.$refs.ruleForm.validate((valid) => {
                if(valid){
                   if(!vues.params.businessLicense){
                       vues.$message.error('有效证件必须上传');
                   }else if(!vues.params.applicationCertDocId){
                       vues.$message.error('认证公函必须上传');
                   }else{
                       this.openstate = false;
                       if(!vues.params.status){
                          vues.params.status = 2;
                       }


                   }
                }
            })
        },
        goEdit:function(e){
            var vues = this;
            for(var key in e){
                vues.$set(this.params, key, e[key]);
            }
        },
        openHandle:function(){
            if(this.$refs.ruleForm){
                this.$refs.ruleForm.clearValidate();
            }
        },
        handleClose:function(){
            for(let key in this.params){
                this.params[key] = '';
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.text-block{
      font-size: 14px;
      margin-right: 20px;
     .bName{
          width: 70px;
          padding-top: 8px;
          float: left;
          text-align: right;
     }
     .bContent{
          margin-left: 90px;
          position: relative;
          margin-bottom: 20px;
          .inpText{
              width: 270px;
          }
          .tips{
              font-size: 12px;
              margin-left: 6px;
              color: #999999;
          }

          .upBtn{
              margin-top: 2px;
          }

     }

}

.text-block:last-child .bContent{
    margin-bottom: 0px;
}

.cbody{
    // padding: 0px;
}

</style>

<style lang="css">

.el-dialog__body{
    padding: 12px 20px !important;
}

.el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// cModel.vue?05ccfe66